module.exports = __webpack_public_path__ + "img/Wing_feathers_MetalRoughness.113843f.jpg";